<template>
  <div class="container">
    <div class="contain">
      <div class="header">
        <h1>登录</h1>
      </div>
      <div class="content">
        <ul>
          <li>
            <span>手机号</span>
            <label>
              <i>
                <img src="http://mp.slzhly.com/pcshop/images/usersign.png" alt />
              </i>
              <input type="text" v-model="username" name="username" maxlength="15" />
            </label>
          </li>
          <li>
            <span>密码</span>
            <label>
              <i>
                <img src="http://mp.slzhly.com/pcshop/images/password.png" alt />
              </i>
              <input type="password" v-model="pwd" name="pwd" id="pwd" maxlength="20" />
            </label>
          </li>
          <li style="line-height: 25px;height: 25px;">
            <router-link :to="{ path:'/enters' }" tag="span">
              <span style="float: left;color: #1e9dff;font-size: 14px;">立即注册</span>
            </router-link>
          </li>
          <li>
            <div class="dltbn" style="color:#ffffff" href @click="submitLogin()">登录</div>
          </li>
        </ul>

        <!-- <div class="content-login">
        <span><van-field v-model="code" center clearable placeholder="请输入短信验证码" error-message="验证码格式错误">
        <div class="content-login"></div>
        <van-button slot="button" size="small" type="primary">发送验证码</van-button>
      </van-field></span>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      username: "",
      pwd:"",
      code: ""
    };
  },
  computed: {
    usernamemsg() {
      if (this.username === "") {
        return "";
      } else if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.username)) {
        return "手机号码格式错误";
      } else {
        return "";
      }
    }
  },
  methods: {
   
    submitLogin() {
      axios
        .get("http://mp.slzhly.com/yxapi//api/UserApi/GetLogin", {
          params: {
            UserName: this.username,
            Password: this.pwd,
           
          }
        })
        .then(res => {
          console.log(7777,res)
          if (res.data.Status === true) {
            this.$message({
              message: "登录成功",
              type: "success"
            });
            sessionStorage.setItem("Status",res.data.Status)
            // console.log(44444,res.data.Status)
            this.$router.push({path:"/",query:{Status: res.data.Status}})
          } else if (res.data.Status === false) {
            this.$message({
              message: "登录失败",
              type: "warning"
            });
          } 
        });
    },

    // submitLogin() {
    //   this.$http
    //     .get("yxapi//api/News/GetNewsList", {
    //       CategoryId: "832e5291-62da-41a3-b8c1-2dadef8761a8",
    //       page: 1,
    //       size: 3
    //     })
    //     .then(res => {
    //       this.geared = JSON.parse(res.data.Result);
    //       this.hotList = this.geared.rows; //热门展项

    //       console.log("geared9665:", this.hotList);
    //       // this.Intr = this.service.rows.Intr;
    //     });
    // }
  }
};
</script>
<style scoped>
/* .container {
  widows: 375px;
} */
.van-field__control {
  height: 30px;
}
.contain {
  width: 90%;
  margin: 0 auto;
}
.content-login {
  display: flex;
  justify-content: space-between;
}
.header h1 {
  width: 100%;
  height: auto;
  overflow: hidden;
  line-height: 50px;
  font-size: 24px;
  color: #1e9dff;
  text-align: center;
  letter-spacing: 1px;
}
.content {
  position: absolute;
  top: 50%;
  margin-top: -235px;
  right: 0;
  /* right: 126px; */
  /* right: 0; */
  width: 395px;
  height: auto;
  background: #fff;
  float: right;
  /* margin: 8em 0; */
  padding: 20px;
  padding-right: 30px;
}
.content h1 {
  width: 100%;
  height: auto;
  overflow: hidden;
  line-height: 50px;
  font-size: 24px;
  color: #1e9dff;
  text-align: center;
  letter-spacing: 1px;
}
.content ul {
  width: 100%;
  height: auto;
  overflow: hidden;
  float: left;
}
.content li {
  width: 100%;
  height: 43px;
  line-height: 40px;
  float: left;
  margin-top: 20px;
}
.content li span {
  /* width: 65px; */
  float: left;
  height: 40px;
  line-height: 43px;
  letter-spacing: 2px;
  text-align: center;
  color: #333;
  font-size: 14px;
}
.content li label {
  width: auto;
  height: 40px;
  float: right;
  border: 1px solid #c1c1c1;
  min-width: 300px;
  border-radius: 3px;
}
.content li label i {
  display: block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  float: left;
}
img {
  vertical-align: middle;
  /* -ms-interpolation-mode: bicubic; */
  border: 0px;
  margin: 8px;
}
.content li label input {
  width: 267px;
  height: 30px;
  background: #fff;
  border: 0px;
  margin: 5px 0px;
  padding-left: 20px;
  border-left: 1px solid #c1c1c1;
  font-size: 14px;
  color: #333;
}
a:link,
a:visited,
a:active {
  color: inherit;
  text-decoration: none;
  display: inline-block;
}
.dltbn {
  width: 83%;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  font-size: 20px;
  letter-spacing: 1em;
  background: #20a3fe;
  display: block;
  float: right;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/assets.vue